var _ellipse, _mask, _g, _mask2, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "15 0 155 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88,
    cy: 64.5865,
    rx: 55.4136,
    ry: 55.4136,
    fill: "#EDEEF0"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -8,
    width: 156,
    height: 128
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9439 58.26L23.2046 65.1718L0.335449 46.9938L19.393 -3.72875L68.0632 -7.24707L129.634 -2.26278L155.728 29.109L135.613 36.2202C140.567 44.5179 143.414 54.2195 143.414 64.5859C143.414 95.19 118.604 120 88.0004 120C57.3963 120 32.5868 95.19 32.5868 64.5859C32.5868 62.4468 32.708 60.336 32.9439 58.26Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.131 0.375977C121.131 0.375977 119.35 5.49879 119.531 9.61147C119.713 13.7242 121.131 19.821 121.131 19.821C121.131 19.821 125.274 23.5729 130.654 36.7407C135.997 49.9085 136.797 53.0472 136.797 53.0472C136.797 53.0472 144.539 61.489 141.558 68.1991C138.578 74.8732 132.835 77.6511 127.092 75.4865C121.349 73.322 121.531 67.4415 121.531 67.4415C121.531 67.4415 116.769 66.8643 110.626 62.7156C104.483 58.5668 100.34 52.506 100.34 52.506C100.34 52.506 86.4549 62.1023 92.9976 78.4087C99.5402 94.7151 107.064 100.415 105.283 112.032C103.502 123.648 102.702 124.406 102.702 124.406C102.702 124.406 17.2177 141.373 -2.01025 118.934C10.7689 84.6032 41.0929 52.4699 41.0929 52.4699L29.0254 57.9535C29.0254 57.9535 28.8437 41.4306 48.835 24.7274C68.8263 8.02412 83.8743 8.2045 92.5977 8.60134C101.321 8.99818 106.265 11.3431 106.265 11.3431C106.265 11.3431 109.245 4.30828 121.131 0.375977Z",
    fill: "#181B26"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -8,
    width: 173,
    height: 129
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2046 65.1728L32.9439 58.261C32.708 60.337 32.5868 62.4478 32.5868 64.5869C32.5868 95.191 57.3963 120 88.0004 120C108.603 120 126.579 108.757 136.128 92.0719C138.484 92.6781 140.955 93.0005 143.5 93.0005C159.792 93.0005 173 79.7929 173 63.5005C173 47.2081 159.792 34.0005 143.5 34.0005C142.913 34.0005 142.329 34.0177 141.751 34.0515L155.728 29.1099L129.634 -2.2618L68.0632 -7.24609L19.393 -3.72777L0.335449 46.9947L23.2046 65.1728Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.141 15C133.141 15 131.36 20.1228 131.542 24.2355C131.723 28.3482 133.141 34.445 133.141 34.445C133.141 34.445 137.285 38.197 142.664 51.3648C148.007 64.5326 148.807 67.6712 148.807 67.6712C148.807 67.6712 156.549 76.113 153.568 82.8232C150.588 89.4973 144.845 92.2751 139.102 90.1105C133.359 87.946 133.541 82.0656 133.541 82.0656C133.541 82.0656 128.779 81.4884 122.636 77.3396C116.494 73.1908 112.35 67.13 112.35 67.13C112.35 67.13 98.4652 76.7263 105.008 93.0327C111.55 109.339 119.074 115.039 117.293 126.656C115.512 138.272 114.713 139.03 114.713 139.03C114.713 139.03 29.228 155.997 10 133.558C22.7792 99.2272 53.1032 67.094 53.1032 67.094L41.0357 72.5775C41.0357 72.5775 40.8539 56.0547 60.8452 39.3514C80.8365 22.6481 95.8845 22.8285 104.608 23.2254C113.331 23.6222 118.275 25.9672 118.275 25.9672C118.275 25.9672 121.255 18.9323 133.141 15Z",
    fill: "white",
    fillOpacity: 0.2,
    stroke: "#737475",
    strokeWidth: 3,
    strokeLinejoin: "round",
    strokeDasharray: "8 4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.7413ee95.svg";
export { ForwardRef as ReactComponent };